// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"styles_tableContainer__1Cvxj","plainHeader":"styles_plainHeader__2qig-","notEditingCell":"styles_notEditingCell__1Kyf0","emptyCell":"styles_emptyCell__7QgPw"};